import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { FileAttachment } from "ng/src/app/notes/shared/file-attachments/file-attachment.model";
import { FileService } from "ng/src/app/files/file.service";
import { Message } from "primeng/api";
import { NoteEntryInput } from "ng/src/app/notes/shared/note-entry.model";

@Component({
	selector: 'lb-note-comment',
	templateUrl: './note-comment.component.html',
	styleUrls: ['./note-comment-component.scss']
})
export class NoteCommentComponent {
	@ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
	
	@Input() noteEntryInput!: NoteEntryInput;
	
	isImage = FileAttachment.isImage;
	getHref = FileAttachment.getHref;
	
	messages: Message[] = [];
	
	constructor(
		private fileService: FileService
	) {}
	
	uploadFiles() {
		const files: File[] = [];
		const filesTooBig: string[] = [];
		const el = this.fileInput.nativeElement;
		for (let i = 0; i < (el.files?.length ?? 0); i++) {
			const file = el.files![i];
			if (file.size < FileService.MAX_FILE_SIZE) {
				files.push(file);
			}
			else {
				filesTooBig.push(file.name);
			}
		}
		
		if (filesTooBig.length) {
			this.displayError('Files too large',
				`The following files were too large to attach: ${filesTooBig.join(', ')}`)
		}
		
		el.value = '';
		this.fileService.uploadFiles(files, this.noteEntryInput.logId)
			.forEach(ob$ => {
				ob$.subscribe(fa => this.addFile(fa))
			});
	}
	
	removeFile(fa: FileAttachment) {
		const values = this.noteEntryInput.commentAttachments;
		const idx = values.indexOf(fa);
		if (idx > -1)
			values.splice(idx, 1);
		
		this.noteEntryInput.commentAttachments = values;
	}
	
	displayError(summary: string, detail: string) {
		this.messages = [{
			severity: 'error',
			summary: summary,
			detail: detail,
			closable: true,
			life: 10000
		}]
	}
	
	private addFile(fa: FileAttachment) {
		const value = this.noteEntryInput.commentAttachments;
		value.push(fa);
		
		this.noteEntryInput.commentAttachments = value;
	}
}